import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {TrackingService} from '../../../services';

@Component({
    selector: 'app-delete-item-modal',
    templateUrl: './delete-item-modal.component.html',
    styleUrls: ['./delete-item-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeleteItemModalComponent {
    public modalRef = inject(VwuiModalRef);
    public modalConfig = inject<VwuiModalConfig<{ title: string; description: string; extraDescription: string | null; }>>(VwuiModalConfig);
    private trackingService = inject(TrackingService);


    form = new UntypedFormGroup({});
    public title: string;
    public description: string;
    public extraDescription: string | null = null;

    constructor() {
        const modalConfig = this.modalConfig;

        this.title = modalConfig.data.title;
        this.description = modalConfig.data.description;
        this.extraDescription = modalConfig.data.extraDescription;
    }

    async submit() {
        try {
            this.modalRef.close(true);
        } catch (e) {
            console.error('Deleting item failed: ', e);
            this.trackingService.exception(e);
        }
    }
}
